import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { InputDatepicker } from 'src/app/core/Models/interfaces/input-datepicker';
import { DatepickerService } from '../service/datepicker.service';


@Component({
  selector: 'app-datePicker-WithRange',
  templateUrl: './datePicker-WithRange.component.html',
  styleUrls: ['./datePicker-WithRange.component.css', '../date-time-picker.component.css'],
})
// export class DatePickerWithRangeComponent implements OnInit,AfterViewInit {
//   @Input() field!: InputDatepicker
//   @Input() form:any
//   @Input() formName:any;
//   @Input() disabled: boolean = false;
//   @Input() isReadOnly: boolean = false;
//   constructor(public datepicker_serv: DatepickerService) { }
//   @ViewChild('main')mainrEF!:ElementRef
//   @ViewChild('showyear')showyearREF!:ElementRef
//   @ViewChild('showallmonth')showallmonthREF!:ElementRef
//   @ViewChild('DAYS')daysREF!:ElementRef
//   @ViewChild('MONTH')monthREF!:ElementRef
//   @ViewChild('datepicker')datepickerREF!:ElementRef




//   mainele!:HTMLElement
//   showyearELE!:HTMLElement
//   showallmonthELE!:HTMLElement
//   daysELE!:HTMLElement
//   monthELE!:HTMLElement
//   datepickerELE!:HTMLElement


//   ngAfterViewInit(): void {
//     this.mainele=this.mainrEF.nativeElement
//     this.showyearELE=this.showyearREF.nativeElement
//     this.showallmonthELE=this.showallmonthREF.nativeElement
//     this.daysELE=this.daysREF.nativeElement
//     this.monthELE=this.monthREF.nativeElement
//     this.datepickerELE=this.datepickerREF.nativeElement

//     document.addEventListener('click', (e: Event) => {
//       if (!e.composedPath().includes(this.datepickerELE)) {
//         if(this.mainele!=null){
//         if (this.mainele.classList.contains('active')) {
//           this.mainele.classList.remove('active');
//         }
//         }
//       }
//     });
//   }
//   range: { start: Date | null; end: Date | null } = {
//     start: null,
//     end: null,
//   };
//   selected: { start: Date | null; end: Date | null } = {
//     start: null,
//     end: null,
//   };
//   months = [
//     'January',
//     'February',
//     'March',
//     'April',
//     'May',
//     'June',
//     'July',
//     'August',
//     'September',
//     'October',
//     'November',
//     'December',
//   ];
//   weekdays = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
//   year!: number;
//   today = new Date();
//   month!: number;
//   days!: any[];
//   selectedDates: Date = new Date();
//   ngOnInit() {
//     this.datepicker_serv.year.subscribe((x: number) => {
//       this.year = x;
//       this.datepicker_serv.month.subscribe((x: number) => {
//         this.month = x;
//         this.days = this.datepicker_serv.generateDays(this.year, this.month);
//       });
//     });
//     window.addEventListener('click', (e: Event) => {
//       if (!e.composedPath().includes(this.datepickerELE)) {
//         if (this.mainele.classList.contains('active')) {
//           this.mainele.classList.remove('active');
//         }
//       }
//     });

//   }




//   toggleDatePicker(e: Event) {
//     if(this.disabled){
//       return;
//     }
//     if (!this.checkEventPathForClass(e.composedPath(), 'main')) {
//       this.mainele.classList.toggle('active');
//       this.showyearELE.classList.remove('active');
//       this.showallmonthELE.classList.remove('active');
//       this.daysELE.classList.remove('inactive');
//       this.monthELE.classList.remove('inactive');
//       if (this.range.start == null && this.range.end == null) {
//         this.datepicker_serv.changeMonth(
//           new Date().getMonth(),
//           new Date().getFullYear()
//         );
//       }else{       
//         if(this.range.end!==null)       
//         this.datepicker_serv.changeMonth(this.range.end.getMonth(), this.range.end.getFullYear())     
//       }
//     }
//   }
//   checkEventPathForClass(path: any, selector: any) {
//     for (let i = 0; i < path.length; i++) {
//       if (path[i].classList && path[i].classList.contains(selector)) {
//         return true;
//       }
//     }

//     return false;
//   }
//   change() {
//     this.datepicker_serv.changeMonth(this.month, this.year);
//   }

//   nextMonth() {
//     if (this.month < 11) {
//       this.month = this.month + 1;
//     } else {
//       this.month = 0;
//       this.year += 1;
//     }
//     this.change();
//   }
//   prevMonth() {
//     if (this.month > 0) {
//       this.month = this.month - 1;
//     } else {
//       this.month = 11;
//       this.year -= 1;
//     }
//     this.change();
//   }
//   incheck = false;
//   selectedDate(day: any) {
//     this.range.end = null;
//     if (!this.incheck) {
//       this.range.start = new Date(day.dateTxt);
//       this.incheck = true;
//       this.datepicker_serv.changeMonth(
//         this.range.start.getMonth(),
//         this.range.start.getFullYear()
//       );
//     } else {
//       let dummydate = new Date(day.dateTxt);
//       this.range.end = new Date();
//       if (this.range.start !== null && this.range.end !== null) {
//         let range = Math.floor(
//           (dummydate.getTime() - this.range.start.getTime()) /
//           1000 /
//           60 /
//           60 /
//           24
//         );
//         if (range >= 0) {
//           this.range.end = new Date(day.dateTxt);
//           this.incheck = false;
//           this.datepicker_serv.changeMonth(
//             this.range.end.getMonth(),
//             this.range.end.getFullYear()
//           );
//           this.datepickerELE.click();
//         } else {
//           this.range.start = new Date(day.dateTxt);
//           this.range.end = null;
//           this.incheck = true;
//           this.datepicker_serv.changeMonth(
//             this.range.start.getMonth(),
//             this.range.start.getFullYear()
//           );
//         }
//       }
//     }
//     this.form.get(this.formName).patchValue(this.valueFormat()?this.valueFormat():null);
//   }
//   monthSelected(e: Event) {
//     this.daysELE.classList.toggle('inactive');
//     this.showallmonthELE.classList.toggle(
//       'active'
//     );
//   }
//   selectYear(e: Event) {
//     this.daysELE.classList.add('inactive');
//     this.monthELE.classList.add('inactive');
//     this.showyearELE.classList.toggle(
//       'active'
//     );
//     this.showallmonthELE.classList.remove(
//       'active'
//     );
//   }
//   yearSelected(e: Event) {
//     this.showallmonthELE.classList.toggle('active');
//     this.showyearELE.classList.toggle('active');
//     this.monthELE.classList.remove('inactive');
//   }
//   valueFormat() {
//     let language = this.field.locale
//     if(language==undefined)language=window.navigator.language
//     if (this.range.start !== null && this.range.end !== null) {
//       return (
//         this.range.start.toLocaleDateString(language,this.field.options) +
//         ` to ` +
//         this.range.end.toLocaleDateString(language,this.field.options)
//       );
//     } else {
//       if(this.field.placeholder!=undefined){
//         if (this.range.start !== null) {
//           return this.range.start.toLocaleDateString(language,this.field.options) + ` to ` +this.field.placeholder;
//         } else {
//           return this.field.placeholder + ` to ` +this.field.placeholder;
//         }
//       }
//       else{
//         if (this.range.start !== null) {
//           return this.range.start.toLocaleDateString(language,this.field.options) + ` to ` +'';
//         } else {
//           return ;
//         }

//       }
//     }
//   }

//   tog() {
//     this.datepickerELE.click();
//   }
//   Reset() {
//     this.form.controls[this.formName].reset();
//     this.range.start=this.range.end=null;
//     this.datepickerELE.click();
//   }


// }
export class DatePickerWithRangeComponent implements OnInit,AfterViewInit {
  @Input() field!: InputDatepicker
  @Input() form:any
  @Input() formName:any;
  formvalue:any;
  @Input() disabled: boolean = false;
  constructor(public datepicker_serv: DatepickerService) { }
  @ViewChild('main')mainrEF!:ElementRef
  @ViewChild('showyear')showyearREF!:ElementRef
  @ViewChild('showallmonth')showallmonthREF!:ElementRef
  @ViewChild('DAYS')daysREF!:ElementRef
  @ViewChild('MONTH')monthREF!:ElementRef
  @ViewChild('datepicker')datepickerREF!:ElementRef;
  @Input() isInValid: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input('isEdit') isEdit: boolean = false;
 




  mainele!:HTMLElement
  showyearELE!:HTMLElement
  showallmonthELE!:HTMLElement
  daysELE!:HTMLElement
  monthELE!:HTMLElement
  datepickerELE!:HTMLElement


  ngAfterViewInit(): void {
    this.mainele=this.mainrEF.nativeElement
    this.showyearELE=this.showyearREF.nativeElement
    this.showallmonthELE=this.showallmonthREF.nativeElement
    this.daysELE=this.daysREF.nativeElement
    this.monthELE=this.monthREF.nativeElement
    this.datepickerELE=this.datepickerREF.nativeElement
    this.formvalue=this.form.controls[this.formName].value;
    document.addEventListener('click', (e: Event) => {
      if (!e.composedPath().includes(this.datepickerELE)) {
        if(this.mainele!=null){
        if (this.mainele.classList.contains('active')) {
          this.mainele.classList.remove('active');
        }
        }
      }
    });
  }
  range: { start: Date | null; end: Date | null } = {
    start: null,
    end: null,
  };
  selected: { start: Date | null; end: Date | null } = {
    start: null,
    end: null,
  };
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  weekdays = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
  year!: number;
  today = new Date();
  month!: number;
  days!: any[];
  selectedDates: Date = new Date();
  ngOnInit() {
    this.datepicker_serv.year.subscribe((x: number) => {
      this.year = x;
      this.datepicker_serv.month.subscribe((x: number) => {
        this.month = x;
        this.days = this.datepicker_serv.generateDays(this.year, this.month);
      });
    });
    window.addEventListener('click', (e: Event) => {
      if (!e.composedPath().includes(this.datepickerELE)) {
        if (this.mainele.classList.contains('active')) {
          this.mainele.classList.remove('active');
        }
      }
    });

  }




  toggleDatePicker(e: Event) {
    if(this.disabled){
      return;
    }
    if (!this.checkEventPathForClass(e.composedPath(), 'main')) {
      this.mainele.classList.toggle('active');
      this.showyearELE.classList.remove('active');
      this.showallmonthELE.classList.remove('active');
      this.daysELE.classList.remove('inactive');
      this.monthELE.classList.remove('inactive');
      if (this.range.start == null && this.range.end == null) {
        this.datepicker_serv.changeMonth(
          new Date().getMonth(),
          new Date().getFullYear()
        );
      }else{       
        if(this.range.end!==null)       
        this.datepicker_serv.changeMonth(this.range.end.getMonth(), this.range.end.getFullYear())     
      }
    }
  }
  checkEventPathForClass(path: any, selector: any) {
    for (let i = 0; i < path.length; i++) {
      if (path[i].classList && path[i].classList.contains(selector)) {
        return true;
      }
    }

    return false;
  }
  change() {
    this.datepicker_serv.changeMonth(this.month, this.year);
  }

  nextMonth() {
    if (this.month < 11) {
      this.month = this.month + 1;
    } else {
      this.month = 0;
      this.year += 1;
    }
    this.change();
  }
  prevMonth() {
    if (this.month > 0) {
      this.month = this.month - 1;
    } else {
      this.month = 11;
      this.year -= 1;
    }
    this.change();
  }
  incheck = false;
  selectedDate(day: any) {
    
    this.range.end = null;
    if (!this.incheck ) {
      this.range.start = new Date(day.dateTxt);
      this.incheck = true;
      this.datepicker_serv.changeMonth(
        this.range.start.getMonth(),
        this.range.start.getFullYear()
      );
    } else {
      let dummydate = new Date(day.dateTxt);
      this.range.end = new Date();
      if (this.range.start !== null && this.range.end !== null) {
        let range = Math.floor(
          (dummydate.getTime() - this.range.start.getTime()) /
          1000 /
          60 /
          60 /
          24
        );
        if (range >= 0) {
          this.range.end = new Date(day.dateTxt);
          this.incheck = false;
          this.datepicker_serv.changeMonth(
            this.range.end.getMonth(),
            this.range.end.getFullYear()
          );
          this.datepickerELE.click();
        } else {
          this.range.start = new Date(day.dateTxt);
          this.range.end = null;
          this.incheck = true;
          this.datepicker_serv.changeMonth(
            this.range.start.getMonth(),
            this.range.start.getFullYear()
          );
        }
      }
    }
    this.form.get(this.formName).patchValue(this.valueFormat()?this.valueFormat():null);
  }
  monthSelected(e: Event) {
    this.daysELE.classList.toggle('inactive');
    this.showallmonthELE.classList.toggle(
      'active'
    );
  }
  selectYear(e: Event) {
    this.daysELE.classList.add('inactive');
    this.monthELE.classList.add('inactive');
    this.showyearELE.classList.toggle(
      'active'
    );
    this.showallmonthELE.classList.remove(
      'active'
    );
  }
  yearSelected(e: Event) {
    this.showallmonthELE.classList.toggle('active');
    this.showyearELE.classList.toggle('active');
    this.monthELE.classList.remove('inactive');
  }
  valueFormat() {
    let language = this.field.locale
    if(language==undefined)language=window.navigator.language
    if (this.range.start !== null && this.range.end !== null) {
      return (
        this.range.start.toLocaleDateString(language,this.field.options) +
        ` to ` +
        this.range.end.toLocaleDateString(language,this.field.options)
      );
    } else {
      if(this.field.placeholder!=undefined){
        if (this.range.start !== null) {
          return this.range.start.toLocaleDateString(language,this.field.options) + ` to ` +this.field.placeholder;
        } else {
          return this.field.placeholder + ` to ` +this.field.placeholder;
        }
      }
      else{
        if (this.range.start !== null) {
          return this.range.start.toLocaleDateString(language,this.field.options) + ` to ` +'';
        } else {
          return ;
        }

      }
    }
  }

  tog() {
    this.datepickerELE.click();
  }
  Reset() {
    if(this.isEdit){
      this.form.controls[this.formName].patchValue(this.formvalue);
      this.datepickerELE.click();
      this.incheck = false;
    }else{
      this.form.controls[this.formName].reset();
      this.range.start=this.range.end=null;
      this.datepickerELE.click();
      this.incheck = false;
    }
    
  
  }
 


}
